/**
 * EqualHousing — the Equal Housing Opportunity mark and wording, shared by the
 * shared landing footer (ClientWelcome) and every tenant footer
 * (ComplianceFooter) so the two cannot drift.
 */

export function EqualHousingMark() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="14"
      height="14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 11 12 4l9 7" />
      <path d="M5 10v10h14V10" />
      <path d="M8 14h8" />
      <path d="M8 17h8" />
    </svg>
  );
}

export function EqualHousingNotice({ className }: { className?: string }) {
  return (
    <span className={className}>
      <EqualHousingMark /> Equal Housing Opportunity
    </span>
  );
}
